import './SeoText.css';
import React, {useState} from 'react';

function SeoText(props) {
  const hideUrlsList = ['/imac/', '/mac-mini/', '/airpods/', '/airpods-2/', '/airpods-pro-2/', '/airpods-3/', '/airpods-max/', '/apple-watch/', '/apple-watch-series-8/', '/apple-watch-ultra/', '/apple-watch-se2/'];

  const [opened, setOpened] = useState(hideUrlsList.includes(window.location.pathname) ? false : props.opened);

  return (
      <div className="ceo-section catalog-seo">
        <div className="container">
          <div className={`ceo-block opened`}>
            <div className="text-block" dangerouslySetInnerHTML={{__html: props.text}}/>
          </div>
        </div>
      </div>
  );
}

export default SeoText;